<script setup lang="ts">
import type { IProps } from './FileList.types'
import { useFileList } from './FileList.composable'
import FileItem from '../FileItem/FileItem.vue'

const props = withDefaults(defineProps<IProps>(), {
  showTitle: true,
  variant: 'card',
})
const { getFileList, getFileItems } = useFileList()
const fileList = await getFileList(props.requestId)
const fileListData = computed(() => fileList.data.value)
const fileItems = computed(() => getFileItems(fileListData.value))
</script>

<template>
  <section
    v-if="fileListData"
    :class="['file-list', `file-list__variant-${props.variant}`]"
  >
    <div class="file-list__container">
      <h3
        v-if="props.showTitle && fileListData.title"
        class="file-list__title"
      >
        {{ fileListData.title }}
      </h3>

      <div class="file-list__items">
        <FileItem
          v-for="(item, index) in fileItems"
          :key="item?.sys?.id || item?.url || item?.label || item?.title || index"
          :item="item"
          :options="{...props.fileItemOptions, ...props.fileItemLinkOptions}"
          :variant="props.variant"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.file-list {
  $root:&;
  @include section-investor();

  & + & {
    padding-top:0;
  }

  &__title {
    @include h8;
    margin-bottom: 2.4rem;
    color: $text-400;
  }

  &__items {
    display: grid;
    gap: 1.6rem;
  }

  &__variant-list {
    #{$root}__title {
      @include h10;
    }
  }

  &__container {
    @include section-investor__container();
  }

  .section & {
    margin-bottom: 0;
    padding: 0;
  }
}
</style>

